import { getBooleanOperatorValuesForCollectionFilter } from '../../../services/filtering/collection-filter-mapping-service';

const tagMapper = (appliedFilter) => {
  const criteria = getBooleanOperatorValuesForCollectionFilter(appliedFilter);
  return {
    normalizableCollectionFilters: [
      {
        column: 'Tag',
        values: [appliedFilter.criterionArgumentValue],
        isIn: criteria.isIn,
        isNull: criteria.isNull,
      },
    ],
  };
};

export default tagMapper;
